import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button, Col, Form, FormControl, Row} from 'react-bootstrap';

import {SB_ENTER_KEY_CODE} from '../../Constants';
import {Conditional} from "../Conditional";
import {KeyboardUtils} from "../../Utils";
import {UPDATE_VERIFICATION_FIELD_VALUE} from "../../Redux/Actions/Types";

export const LoginComponent = (props) => {
    const dispatch = useDispatch();
    const loginState = useSelector(state => state.loginState);

    const updateField = (field, value) => {
        dispatch({type: UPDATE_VERIFICATION_FIELD_VALUE, field, value})
    };

    return (
        <Form>
            <Row key={1} className="top10">
                <Col md={3}>
                    <span className="login-form-label">Email</span>
                </Col>
                <Col md={9}>
                    <FormControl
                        autoComplete="username"
                        type="email"
                        name="email"
                        value={loginState.fields.email}
                        onChange={(e) => updateField('email', e.target.value)}
                        onKeyPress={(x) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, x, () => props.Login())}
                        autoFocus
                    />
                </Col>
            </Row>
            <Row key={2} className="top10">
                <Col md={3}>
                    <span className="login-form-label">Password</span>
                </Col>
                <Col md={9}>
                    <FormControl
                        autoComplete="current-password"
                        type="password"
                        name="password"
                        value={loginState.fields.password}
                        onChange={(e) => updateField('password', e.target.value)}
                        onKeyPress={(x) => KeyboardUtils.handleKeyPress(SB_ENTER_KEY_CODE, x, () => props.Login())}
                    />
                </Col>
            </Row>
            <Conditional Condition={!props.HideButtons}>
                <Row key={3} className="top10 login-btn">
                    <Col md={3} />
                    <Col md={9}>
                        <Button onClick={() => props.Login()} variant="primary">Login</Button>
                    </Col>
                </Row>
                <Row key={4} className="top10 forgot-password">
                    <Col md={3} />
                    <Col md={9}>
                        <a onClick={() => props.ForgotPassword()}>Forgot Password?</a>
                    </Col>
                </Row>
            </Conditional>
        </Form>
    );
};

